import { useQuery } from "@tanstack/react-query";
import { getProjects, reactQueryCacheAndRefetchOptions } from "@";
import { projectsKeys } from "./keys";
import type { ProjectsListResponse, QueryParams } from "../../types";

// Query hook for fetching projects list
export const useProjectsQuery = (params: QueryParams | null) => {
  return useQuery<ProjectsListResponse>({
    queryKey: projectsKeys.list(params as QueryParams),
    queryFn: async () => {
      const { data } = await getProjects(
        params?.page || 1,
        params?.perSize || 10,
        params?.search || {},
      );
      return data;
    },
    enabled: !!params,
    ...reactQueryCacheAndRefetchOptions,
  });
};
